// extracted by mini-css-extract-plugin
export default {"root":"Reviews_root__vDzav","average":"Reviews_average__eyX6W","summary":"Reviews_summary__q-ulI","reviews":"Reviews_reviews__u1rwg"};